<template>
  <div>
    <mdb-card class="mb-4" v-if="rssData">
      <mdb-card-body v-if="error">
        <error :error="error"/>
      </mdb-card-body>
      <mdb-card-body v-if="rssData">
        <div v-if="rssData.image" class="text-center">
          <img :src="rssData.image" style="max-width: 75%;"/>
        </div>
        <div v-if="rssData.title" class="text-center"><h4>{{ rssData.title }}</h4></div>

        <div v-if="rssData.items.length > 10" class="text-center">
          <mdb-btn @click="prevSet" :disabled="offset == 0" icon="arrow-left" size="sm" rounded/>
          <mdb-btn @click="nextSet" :disabled="offset > (rssData.items.length - 10)" icon="arrow-right"
                   size="sm" rounded/>
        </div>
        <mdb-list-group>
          <mdb-list-group-item v-bind:key="item.id"
                               v-if="inRange(i)"
                               v-for="(item,i) in rssData.items">
            <div>
              <a href="" @click.prevent="viewItem(item)">{{ item.title }}</a>
              <div class="small" v-if="item.summary && !item.summaryIsHtml">{{ item.summary }}</div>
            </div>
          </mdb-list-group-item>
        </mdb-list-group>
        <a target="_blank" :href="rssData.siteUrl" v-if="rssData.siteUrl">Visit Site
          <mdb-icon icon="external-link"/>
        </a>
      </mdb-card-body>
    </mdb-card>
    <mdb-modal size="lg" v-if="showModal" @close="showModal=false" removeBackdrop scrollable>
      <mdb-modal-header :close="true" class="secondary-color text-white"></mdb-modal-header>
      <mdb-modal-body>
        <div v-html="modalHtml" class="feed-html">&nbsp;</div>
        <a @click="showModal=false" v-if="modalUrl" target="_blank" :href="modalUrl">View on Site <mdb-icon icon="external-link"/></a>
      </mdb-modal-body>
    </mdb-modal>


  </div>
</template>

<script>
import error from '../common/Error'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardText,
  mdbCardTitle,
  mdbContainer,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem,
  mdbModal,
  mdbModalBody,
  mdbModalHeader
} from 'mdbvue';

export default {
  name: 'rssFeedSection',
  components: {
    mdbBtn,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardText,
    mdbCardTitle,
    mdbIcon,
    mdbListGroup,
    mdbListGroupItem,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    error
  },
  props: {
    group: {
      type: Object,
      default: null
    },
    section: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      rssData: null,
      error: false,
      offset: 0,
      modalHtml: "",
      modalUrl: null,
      showModal : false
    };
  },
  mounted() {
    if (!this.group) {
      return
    }
    this.rssData = this.section.data
  },
  methods: {
    viewItem(item) {
      this.modalHtml = ""
      this.modalUrl = null
      if (item.summaryIsHtml) this.modalHtml = item.summary
      if (item.content) this.modalHtml += item.content
      if (item.url) this.modalUrl = item.url
      if (this.modalHtml == "") window.open(item.url, "_blank")
      else this.showModal = true
    },
    nextSet() {
      this.offset += 9
    },
    prevSet() {
      this.offset -= 9
    },
    inRange(i) {
      if (i >= this.offset && i <= (this.offset + 10)) return true
      else return false
    },
  }
};
</script>

